import { useTranslation } from '@sm360/hooks'
import { Button, Drawer } from '@sm360/ui-library'
import React from 'react'

import { Context } from '../../configs/state.manager'
import '@sm360/payment-calculator-360/dist/views/drawer/drawer.view.css'

const DrawerView = ({ children }) => {
    const {
        state: { calculatorCtaVersion },
    } = React.useContext(Context)

    const { t } = useTranslation()

    return (
        <Drawer
            tabIndex={0}
            trigger={
                <div>
                    <Button className={`a-button ${calculatorCtaVersion}`} label={t('pc.configureMyPayment')} />
                </div>
            }
        >
            {children}
        </Drawer>
    )
}

export default DrawerView
